import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './components/Auth/AuthContext';
import { CartProvider } from './components/Store/CartContext';

import './styles/style.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  </HelmetProvider>
);
